import {
  IProductCategory
} from '@vierkant-software/types__api';
import { FullSyncableServiceBase } from "./sync.service";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

export enum ProductCategoryDetailLevel {
    info = 0
}

type ProductCategoryDetailType = {
    [ProductCategoryDetailLevel.info]: Partial<IProductCategory>;
};

@Injectable({ providedIn: "root" })
export class ProductCategorySyncService extends FullSyncableServiceBase<ProductCategoryDetailType, ProductCategoryDetailLevel> {
    override getDefaultValue(): ProductCategoryDetailType[ProductCategoryDetailLevel] {
        return {} as ProductCategoryDetailType[ProductCategoryDetailLevel];
    }
    protected readonly syncName = "productCategorySync";
    protected override get usesDeviceSession(): boolean {
        return environment.isCashRegister;
    }
}
